import { render, staticRenderFns } from "./marketxs.vue?vue&type=template&id=7e8eb6e1&scoped=true"
import script from "./marketxs.vue?vue&type=script&lang=js"
export * from "./marketxs.vue?vue&type=script&lang=js"
import style0 from "./marketxs.vue?vue&type=style&index=0&id=7e8eb6e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8eb6e1",
  null
  
)

export default component.exports